import React, { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementType } from 'react';
import styled from '@emotion/styled';
import { Stack } from './Stack';
import { convertOldHStackProps } from './converter.old';
import type { OldHStackProps } from './converter.old';

export type { VerticalAlignment } from './converter.old';
export type HStackProps = OldHStackProps;
type HStackComponentProps = HStackProps & ComponentPropsWithoutRef<'div'> & { as?: ElementType };

/** @deprecated Stack을 사용해주세요. */
const HStackBase = forwardRef<HTMLDivElement, HStackComponentProps>((props, ref) => (
  <Stack {...convertOldHStackProps(props)} ref={ref} />
));

HStackBase.displayName = 'HStackBase';

export const HStack = styled(HStackBase)``;

HStack.displayName = 'HStack';
